import { Card, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomTable from "../common/Table";

function MaxStayAnalytics() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const {
        status,
        data,
        refetch: getTableData,
    } = useQuery("max-stay-analytics", async () => {
        return await HTTP("/analytics/getRecurringGuestMaxDayHotel", {
            staff_id,
        });
    });

    useEffect(() => {
        getTableData;
    }, []);

    useEffect(() => {
        if (status == "success") {
            const { data: tableData, total } = data;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [status, data]);

    return (
        <Card className="chartCard chartWithDatePicker">
            {status !== "loading" && status !== "idle" ? (
                <CustomTable
                    columns={[
                        {
                            title: "Hotel",
                            key: "hotel_name",
                            dataIndex: "hotel_name",
                        },
                        {
                            title: "No. of Guest",
                            key: "count",
                            dataIndex: "count",
                        },
                    ]}
                    tableData={tableData}
                    totalRecords={totalRecords}
                    isScroll
                />
            ) : (
                <Skeleton active={true} title={false} />
            )}
        </Card>
    );
}

export { MaxStayAnalytics };
